<template>
  <div style="background: #fff; min-height: 100%; width: 100%">
    <img :src="logoGif" style="width:300px;margin-left: 35px; margin-top: 20px" />
    <div style="display: flex">
      <div style="flex: 3; display: flex">
        <div style="width: 100%; height: 100%; display: flex">
          <img
            :src="loginImg"
            style="
              align-self: center;
              margin: 0px auto;
              width: 100%;
              height: auto;
              object-fit: cover;
              align-items: center;
            "
          />
        </div>
      </div>
      <div style="flex: 2" class="login-container">
        <el-form
          ref="loginForm"
          :model="loginForm"
          :rules="loginRules"
          class="login-form"
          autocomplete="on"
          label-position="left"
        >
          <div class="title-container">
            <h3 class="title">慢病健康管理平台</h3>
          </div>

          <el-form-item prop="username">
            <span class="svg-container">
              <svg-icon icon-class="user" />
            </span>
            <el-input
              ref="username"
              v-model="loginForm.loginId"
              placeholder="用户名"
              name="loginId"
              type="text"
              tabindex="1"
              autocomplete="on"
            />
          </el-form-item>

          <el-tooltip
            v-model="capsTooltip"
            content="Caps lock is On"
            placement="right"
            manual
          >
            <el-form-item prop="password">
              <span class="svg-container">
                <svg-icon icon-class="password" />
              </span>
              <el-input
                :key="passwordType"
                ref="password"
                v-model="loginForm.pwd"
                :type="passwordType"
                placeholder="密码"
                name="pwd"
                tabindex="2"
                autocomplete="on"
                @keyup.native="checkCapslock"
                @blur="capsTooltip = false"
                @keyup.enter.native="handleLogin"
              />
              <span class="show-pwd" @click="showPwd">
                <svg-icon
                  :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'"
                />
              </span>
            </el-form-item>
          </el-tooltip>

          <el-button
            :loading="loading"
            type="primary"
            style="width: 100%; margin-bottom: 30px"
            @click.native.prevent="handleLogin"
            >登录</el-button
          >
        </el-form>

        <el-dialog title="Or connect with" :visible.sync="showDialog">
          Can not be simulated on local, so please combine you own business
          simulation! ! !
          <br />
          <br />
          <br />
          <social-sign />
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { validUsername } from "@/utils/validate";
import logoGif from "@/assets/images/logo.png";
import loginImg from "@/assets/images/loginBack.jpg";
import { login } from '@/api/user'
import { getToken, setToken, removeToken, getName, setName, getId, setId, setPerms } from '@/utils/auth'

export default {
  name: "Login",
  components: { },
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!validUsername(value)) {
        callback(new Error("Please enter the correct user name"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error("The password can not be less than 6 digits"));
      } else {
        callback();
      }
    };
    return {
      logoGif: logoGif + "?" + +new Date(),
      loginImg: loginImg + "?" + +new Date(),
      loginForm: {
        loginId: "",
        pwd: "",
      },
      loginRules: {},
      passwordType: "password",
      capsTooltip: false,
      loading: false,
      showDialog: false,
      redirect: undefined,
      otherQuery: {},
      content: {},
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        const query = route.query;
        if (query) {
          this.redirect = query.redirect;
          this.otherQuery = this.getOtherQuery(query);
        }
      },
      immediate: true,
    },
  },
  created() {
    // window.addEventListener('storage', this.afterQRScan)
  },
  mounted() {
    if (this.loginForm.loginId == "") {
      this.$refs.loginId.focus();
    } else if (this.loginForm.pwd == "") {
      this.$refs.pwd.focus();
    }
  },
  destroyed() {
    // window.removeEventListener('storage', this.afterQRScan)
  },
  methods: {
    checkCapslock(e) {
      const { key } = e;
      this.capsTooltip = key && key.length === 1 && key >= "A" && key <= "Z";
    },
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
      this.$nextTick(() => {
        this.$refs.pwd.focus();
      });
    },
    handleLogin() {
      console.log("this.loginForm:",this.loginForm);
      console.log("this.redirect:",this.redirect);

      // const { loginId, pwd } = this.loginForm

      // this.$refs.loginForm.validate((valid) => {
      //   console.log("valid:",valid);
      //   login({ username: loginId.trim(), password: pwd }).then(response => {
      //   const dt = response.data
      //   setToken(dt.access_token)
      //   window.location.href = '/'
      // }).catch(error => {
      //   reject(error)
      // })
      // });

      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          // this.$router.push({path: '/'});
          this.loading = true,
            this.$store
              .dispatch("user/login", this.loginForm)
              .then((response) => {
                console.log("this.otherQuery:",this.otherQuery);
                const home = '/cloudhealth/v2/diseasemanagement/index.html' // window.location.href是动态跳转，会刷新页面
                const target = this.redirect ? home + '#' + this.redirect : home
                window.location.href = target
                this.loading = false;
                console.log("response");
                console.log(response);

                console.log(this.$store.getters.name);
                console.log(this.$store.getters.perms);
              })
              .catch(() => {
                this.loading = false;
              });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== "redirect") {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    },
    // afterQRScan() {
    //   if (e.key === 'x-admin-oauth-code') {
    //     const code = getQueryObject(e.newValue)
    //     const codeMap = {
    //       wechat: 'code',
    //       tencent: 'code'
    //     }
    //     const type = codeMap[this.auth_type]
    //     const codeName = code[type]
    //     if (codeName) {
    //       this.$store.dispatch('LoginByThirdparty', codeName).then(() => {
    //         this.$router.push({ path: this.redirect || '/' })
    //       })
    //     } else {
    //       alert('第三方登录失败')
    //     }
    //   }
    // }
  },
};
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg: #283443;
$light_gray: #fff;
$cursor: #283443;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
  }
}

/* reset element-ui css */
.login-container {
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;

    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: #283443;
      height: 47px;
      caret-color: $cursor;

      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px #e6e6e6 inset !important;
        -webkit-text-fill-color: #283443 !important;
      }
    }
  }

  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }
}
</style>

<style lang="scss" scoped>
$bg: #fff;
$dark_gray: #889aa4;
$light_gray: #eee;

.login-container {
  min-height: 100%;
  width: 100%;
  background-color: $bg;
  overflow: hidden;

  .login-form {
    position: relative;
    width: 520px;
    max-width: 100%;
    padding: 20px 35px 0;
    margin: 0 auto;
    overflow: hidden;
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    position: relative;

    .title {
      font-size: 26px;
      color: #283443;
      margin: 0px auto 40px auto;
      text-align: center;
      font-weight: bold;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }

  .thirdparty-button {
    position: absolute;
    right: 0;
    bottom: 6px;
  }

  @media only screen and (max-width: 470px) {
    .thirdparty-button {
      display: none;
    }
  }
}
</style>
